import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const KitchenSidebar = ({ collapsed, visible, onLogout }) => {
  const location = useLocation();

  const navItems = [
    {
      path: '/kitchen/dashboard',
      icon: 'bi bi-speedometer2',
      label: 'Dashboard',
      exact: true
    },
    {
      path: '/kitchen/display',
      icon: 'bi bi-display',
      label: 'Kitchen Display',
      exact: false
    },
    {
      path: '/kitchen/order-history',
      icon: 'bi bi-clock-history',
      label: 'Order History',
      exact: false
    },
    {
      path: '/logout',
      icon: 'bi bi-box-arrow-right',
      label: 'Logout',
      exact: true,
      isLogout: true
    }
  ];

  const isActive = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className={`dms-sidebar ${collapsed ? 'collapsed' : ''} ${visible ? 'show' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <div className="brand-logo">
            <img
              src="/murgaroma_logo.png"
              alt="Murgaroma"
              className="sidebar-logo-img"
            />
          </div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item, index) => (
          <div key={index} className="nav-item">
            {item.isLogout ? (
              <div
                className="nav-link"
                onClick={onLogout}
                style={{ cursor: 'pointer' }}
                title={collapsed ? item.label : ''}
              >
                <i className={item.icon}></i>
                {!collapsed && <span className="nav-label">{item.label}</span>}
              </div>
            ) : (
              <Link
                to={item.path}
                className={`nav-link ${isActive(item.path, item.exact) ? 'active' : ''}`}
                title={collapsed ? item.label : ''}
              >
                <i className={item.icon}></i>
                {!collapsed && <span className="nav-label">{item.label}</span>}
              </Link>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
};

export default KitchenSidebar;
